import React from "react";
import Button from "./Button";
// interface ModalHeadingProps {
//   heading?: string;
//   subHeading?: string;
//   closeIcon?: string;
//   customClass?: string;
//   customCloseClass?: string;
//   style?: React.CSSProperties;
//   onClose?: React.MouseEventHandler<HTMLButtonElement>;
// }

const ModalHeading = (props) => {
  return (
    <div
      className={`modal__heading--container ${props.customClass || ""}`}
      style={props.style}
    >
      <div className="displayflex displayflexCol">
        <h2 className="modal__heading2">{props.heading}</h2>
        {props.subHeading ? (
          <h4 className="modal_sub_heading2">{props.subHeading}</h4>
        ) : null}
      </div>
      {props.children}
      <div style={{display:'flex',gap:'1rem'}}>
        {props.download ? (
          <Button
            span={false}
            label="Preview PDF"
            // icon="icon-file_download"
            onClick={props.onDownload}
            submitButtonStyle={{
              borderRadius: "0.6rem",
              display: "flex",
              flexDirection: "row-reverse",
            }}
          />
        ) : null}
        {props.onClose ? (
          <button onClick={props.onClose} className="modal__heading--btn">
            <svg
              className={
                props.customCloseClass
                  ? props.customCloseClass
                  : "modal__heading--icon"
              }
              style={{ fill: "#888888" }}
            >
              <use
                xlinkHref={`/assets/sprite.svg#icon-${
                  props.closeIcon ? props.closeIcon : "cancel"
                }`}
              />
            </svg>
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default ModalHeading;
